import React from 'react';
import PageBanner from 'components/banners/PageBanner';
import Features from 'components/Features';
import { Col, Container, Row, Image } from 'react-bootstrap';
import styles from './addons.module.scss';
import { Helmet } from 'react-helmet';
import RequestDemoButton from 'components/RequestDemoButton';
const FEATURE_DATA = [
  {
    id: 1,
    title: 'Targeted Recipients',
  },
  {
    id: 2,
    title: 'Text to Speech',
  },
  {
    id: 3,
    title: 'Text to SMS',
  },
  {
    id: 4,
    title: 'Upload Custom Recordings',
  },
];
function AutoDialer() {
  return (
    <div>
      <PageBanner
        title="Client Communications made easy"
        subtitle="Texter & Auto Dialer"
      />
      <ClienDesk />
      <div className="floralbg-blue">
        <Container className="overflow-auto">
          <Features
            data={FEATURE_DATA}
            variant="secondary"
            title="Features"
            itemsPerRow={4}
            itemClass={styles.featureItem}
          />
        </Container>
      </div>
    </div>
  );
}

function ClienDesk() {
  return (
    <div className={styles.clientDeskWrapper}>
      <Helmet>
        <title>Auto Dialer Texter - CAP60</title>
        <meta
          name="description"
          content="Cap60’s auto dial texter makes communicating with clients faster and more efficient. Make easy communication with client."
        />
        <meta
          name="keyword"
          content="auto dialer texter, cap60 auto dialer texter"
        />
      </Helmet>
      <Container>
        <Row>
          <Col md="7">
            <div className="heading">
              <h2>CAP60 Texter & Auto Dialer</h2>
            </div>
            <p>
              CAP60’s AutoDialer & Texter makes communicating with clients
              faster and more efficient. Simply run a report to select the
              individuals you want to call or text, type out or record and
              upload your message, then instantly send that message to everyone
              you selected or you can schedule them to go out at a later date
              and/or time.
            </p>
            <p>
              CAP60’s AutoDialer & Texter uses our own Voice Over IP, so it
              doesn’t tie up your phone lines or charge for long distance calls.
              After each message is sent you can run reports to see your
              successful and/or unsuccessful calls or texts in order to find out
              whose contact information needs to be updated.
            </p>

            <RequestDemoButton />
          </Col>
          <Col md="5">
            <div className={styles.rightDark}>
              <Image height={300} src={'/images/auto-dialer.png'} />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default AutoDialer;
